"use client"
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import parse from "html-react-parser";

const HomeTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch("/data/home-testimonials.json");
        const data = await response.json();
        setTestimonials(data.testimonials);
      } catch (error) {
        console.error("Error loading testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <div className="HomeTestimonials">
      <Swiper
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        spaceBetween={10}
        slidesPerView={3}
        pagination={{ clickable: true }}
        breakpoints={{
          200: { slidesPerView: 1, spaceBetween: 0 },
          600: { slidesPerView: 1, spaceBetween: 0 },
          700: { slidesPerView: 2, spaceBetween: 0 },
          1300: { slidesPerView: 3, spaceBetween: 0 },
        }}
        rewind={true}
        navigation={true}
        // modules={[Navigation]}
        modules={[Autoplay, Navigation]}
        className="mySwiper"
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <div className="BoxTestimonial">
              <div className="AutorName">{testimonial.author}</div>
              <div className="ContStars">
                <div className="MaskStar"></div>
                <div
                  className="BarStars"
                  style={{ width: testimonial.stars * 20 + "%" }}
                ></div>
              </div>
              <div className="CommentText">{parse(testimonial.comment)}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeTestimonials;
